<h2 mat-dialog-title>{{ 'ASSOCIATIONS.MODAL.TITLE_ASSOCIATION' | translate }}</h2>
<mat-dialog-content>
  <glxy-form-field>
    <mat-radio-group (change)="setPrimaryAssociation($event.value)">
      @for (association of associations; track association.crmObjectId) {
        @if (association.crmObjectId) {
          <glxy-label class="primary-text-color">{{
            displayNamesByObjectId.get(association.crmObjectId ?? '')
          }}</glxy-label>
          <div class="radio-wrapper">
            <mat-radio-button
              class="primary-text-color"
              [value]="association.crmObjectId"
              [checked]="primaryAssociation() === association.crmObjectId"
            >
              {{ 'ASSOCIATION_PANEL.SET_PRIMARY_MODAL.RADIO_BUTTON_TEXT' | translateByObjectType: objectType }}
              <extended>
                {{ 'ASSOCIATION_PANEL.SET_PRIMARY_MODAL.RADIO_BUTTON_DESCRIPTION' | translateByObjectType: objectType }}
              </extended>
            </mat-radio-button>
            <crm-edit-association-tags
              [tags]="[]"
              [associationType]="data.associationType"
              (tagsChanged)="tagsChanged(association.crmObjectId ?? '', $event)"
            ></crm-edit-association-tags>
          </div>
        }
      }
    </mat-radio-group>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">
    {{ 'ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save()">
    {{ 'ACTIONS.ADD' | translate }}
  </button>
</mat-dialog-actions>
